export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const RELOAD_TOP_BAR = 'RELOAD_TOP_BAR';
export const REFRESH_TEMPLATE = 'REFRESH_TEMPLATE';
export const UPDATE_REFRESH_TEMPLATE_TIME = 'REFRESH_TEMPLATE';
export const UPDATE_SIGNUP_FORM = 'UPDATE_SIGNUP_FORM';
export const CLEAR_SIGNUP_FORM = 'CLEAR_SIGNUP_FORM';
export const RELOAD_CONTACT_LIST = 'RELOAD_CONTACT_LIST';
export const RELOAD_CONTACT_OVERVIEW = 'RELOAD_CONTACT_OVERVIEW';


export const updateSignupForm = formPayload => ({
    type: UPDATE_SIGNUP_FORM,
    payload: formPayload,
});

export const clearSignupForm = () => ({
    type: CLEAR_SIGNUP_FORM,
})

export const reloadContactList = () => ({
    type: RELOAD_CONTACT_LIST
});

export const reloadTopbar = () => ({
    type: RELOAD_TOP_BAR
});

export const reloadContactOverview = () => ({
    type: RELOAD_CONTACT_OVERVIEW
});

export const refreshTemplates = () => ({
    type: REFRESH_TEMPLATE,
})

export const updateRefreshTemplatesTime = (newTime) => ({
    type: UPDATE_REFRESH_TEMPLATE_TIME,
    payload: newTime,
})

export const setLoginSuccess = res => ({
    type: LOGIN_SUCCESS,
    payload: res,
});

export const setLoadingStatus = isLoading => ({
    type: UPDATE_LOADING_STATUS,
    payload: isLoading,
});


const logoutUser = res => ({
    type: LOGOUT,
    payload: {},
});
// Logout and delete session
export const onLogout = token => dispatch => {
    dispatch(logoutUser());
};